import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { asArray } from '@olivierpascal/helpers';
import stylex from '@stylexjs/stylex';
import { createPolymorphicComponent } from '../../helpers/react/polymorphicComponentTypes';
import { ButtonBase } from '../../components/ButtonBase';
import { SvgIcon } from '../../components/SvgIcon';
import { iconCheckMark } from '../../assets/icons';
import { ColorTag } from '../../components/ColorTag';
import { useStyles } from '../../hooks/useStyles';
import { colorButtonButtonBaseStyles, colorButtonColorTagStyles, colorButtonFocusRingStyles, colorButtonStateLayerStyles, colorButtonStyles, } from './ColorButton.styles';
import { colorButtonStateTokens } from './ColorButton.state.stylex';
import { colorButtonTheme } from './ColorButton.stylex';
const localStyles = stylex.create({
    backgroundColor: (color) => ({
        [colorButtonStateTokens.containerColor]: color,
    }),
});
export const ColorButton = createPolymorphicComponent(forwardRef(function ColorButton(props, forwardedRef) {
    const { styles, sx, innerStyles, children, selected, backgroundColor, foregroundColor, ...other } = props;
    const { combineStyles, globalStyles } = useStyles({
        name: 'ColorButton',
        styles: [colorButtonStyles, styles],
    });
    return (_jsx(ButtonBase, { sx: [
            colorButtonTheme,
            globalStyles,
            combineStyles('host'),
            backgroundColor
                ? localStyles.backgroundColor(backgroundColor)
                : undefined,
            sx,
        ], styles: [
            colorButtonButtonBaseStyles,
            ...asArray(innerStyles?.buttonBase),
        ], innerStyles: {
            ...innerStyles,
            stateLayer: [
                colorButtonStateLayerStyles,
                ...asArray(innerStyles?.stateLayer),
            ],
            focusRing: [
                colorButtonFocusRingStyles,
                ...asArray(innerStyles?.focusRing),
            ],
        }, ...other, ref: forwardedRef, children: _jsx(ColorTag, { styles: [
                colorButtonColorTagStyles,
                ...asArray(innerStyles?.colorTag),
            ], backgroundColor: backgroundColor, foregroundColor: foregroundColor, label: children, icon: selected ? _jsx(SvgIcon, { icon: iconCheckMark }) : undefined }) }));
}));
